module.exports = __webpack_public_path__ + "img/006-user.6328e654.svg";